import { useDisplayGlucoseValue } from "./useDisplayGlucoseValue"

export function useReadableGlucoseValue(value: number): string {
  const displayGlucoseValue = useDisplayGlucoseValue()
  return displayGlucoseValue(value)
}
